module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/repurchase/repurchase.component.html
// module id = 1275
// module chunks = 0